<template>
    <div class="flex gap-2 xl:flex-row flex-col items-start mb-4">
        <div class="w-full xl:w-1/3">
          <div :class="'input-wrapper ' + (form.type.error_type)">
            <label class="text-xs mb-1">Type</label>
            <select  v-model="form.type.value" @keyup="validateFields(['type'])" class="placeholder-theme-878686 h-[40px] block border-none rounded bg-gray-black w-full text-sm text-theme-white">
              <option value="">--Select--</option>
              <option value="discount_percentage">Discount Reward</option>
              <option value="discount_flat">Flat Value</option>
              <option value="item">Item Reward</option>
              <!-- <option value="custom">Custom Reward</option> -->
            </select>
            <p class="field-error label-text mt-1" v-if="form.type.error_message" v-text="form.type.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-2/3" v-if="form.type.value=='item'">
          <div :class="'input-wrapper '">
            <label class="text-xs mb-1">Reward (*Single Item Only)</label>
            <div class="relative">
              <svg class="absolute top-[12px] left-1" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.820312 3.41406V2.8125C0.820312 2.38021 0.914062 1.98698 1.10156 1.63281C1.28906 1.27865 1.55729 0.994792 1.90625 0.78125C2.25521 0.567708 2.66927 0.460938 3.14844 0.460938C3.63802 0.460938 4.05469 0.567708 4.39844 0.78125C4.7474 0.994792 5.01562 1.27865 5.20312 1.63281C5.39062 1.98698 5.48438 2.38021 5.48438 2.8125V3.41406C5.48438 3.83594 5.39062 4.22396 5.20312 4.57812C5.02083 4.93229 4.75521 5.21615 4.40625 5.42969C4.0625 5.64323 3.64844 5.75 3.16406 5.75C2.67969 5.75 2.26042 5.64323 1.90625 5.42969C1.55729 5.21615 1.28906 4.93229 1.10156 4.57812C0.914062 4.22396 0.820312 3.83594 0.820312 3.41406ZM1.90625 2.8125V3.41406C1.90625 3.65365 1.95052 3.88021 2.03906 4.09375C2.13281 4.30729 2.27344 4.48177 2.46094 4.61719C2.64844 4.7474 2.88281 4.8125 3.16406 4.8125C3.44531 4.8125 3.67708 4.7474 3.85938 4.61719C4.04167 4.48177 4.17708 4.30729 4.26562 4.09375C4.35417 3.88021 4.39844 3.65365 4.39844 3.41406V2.8125C4.39844 2.56771 4.35156 2.33854 4.25781 2.125C4.16927 1.90625 4.03125 1.73177 3.84375 1.60156C3.66146 1.46615 3.42969 1.39844 3.14844 1.39844C2.8724 1.39844 2.64062 1.46615 2.45312 1.60156C2.27083 1.73177 2.13281 1.90625 2.03906 2.125C1.95052 2.33854 1.90625 2.56771 1.90625 2.8125ZM6.35938 9.82031V9.21094C6.35938 8.78385 6.45312 8.39323 6.64062 8.03906C6.82812 7.6849 7.09635 7.40104 7.44531 7.1875C7.79427 6.97396 8.20833 6.86719 8.6875 6.86719C9.17708 6.86719 9.59375 6.97396 9.9375 7.1875C10.2865 7.40104 10.5547 7.6849 10.7422 8.03906C10.9297 8.39323 11.0234 8.78385 11.0234 9.21094V9.82031C11.0234 10.2474 10.9297 10.638 10.7422 10.9922C10.5599 11.3464 10.2943 11.6302 9.94531 11.8438C9.60156 12.0573 9.1875 12.1641 8.70312 12.1641C8.21875 12.1641 7.80208 12.0573 7.45312 11.8438C7.10417 11.6302 6.83333 11.3464 6.64062 10.9922C6.45312 10.638 6.35938 10.2474 6.35938 9.82031ZM7.44531 9.21094V9.82031C7.44531 10.0599 7.48958 10.2891 7.57812 10.5078C7.67188 10.7214 7.8125 10.8958 8 11.0312C8.1875 11.1615 8.42188 11.2266 8.70312 11.2266C8.98438 11.2266 9.21615 11.1615 9.39844 11.0312C9.58594 10.8958 9.72396 10.7214 9.8125 10.5078C9.90104 10.2943 9.94531 10.0651 9.94531 9.82031V9.21094C9.94531 8.96615 9.89844 8.73698 9.80469 8.52344C9.71615 8.3099 9.57812 8.13802 9.39062 8.00781C9.20833 7.8724 8.97396 7.80469 8.6875 7.80469C8.41146 7.80469 8.17969 7.8724 7.99219 8.00781C7.8099 8.13802 7.67188 8.3099 7.57812 8.52344C7.48958 8.73698 7.44531 8.96615 7.44531 9.21094ZM9.04688 2.24219L3.49219 11.1328L2.67969 10.6172L8.23438 1.72656L9.04688 2.24219Z" fill="white"/>
              </svg>
              <div class="flex flex-row relative">
                <input v-model="form.name.value" placeholder="Select An Item"
                class="px-2 placeholder-theme-878686 block h-[40px] truncate relative border-none rounded bg-gray-black w-full text-sm text-theme-white">
               
                <button @click="showCategoryWithProductModal" class="p absolute px-2 my-1 rounded border hover:bg-theme-green-300 bg-gray-black border-theme-green top-[3px] right-[28px]">{{form.name.value?'Selected':'Select'}}</button>
                
                <div class="w-[20px] h-[40px] p-2">
                  <div v-if="index+1==total" @click="addReward" class="cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z" fill="white"/>
                    </svg>
                  </div>
                  <div v-else @click="removeReward" class="cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#F53333"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="w-full xl:w-2/3 flex gap-2" v-else-if="form.type.value=='custom'">
          <div class="w-1/3">
            <div :class="'input-wrapper '">
              <label class="text-xs mb-1">Custom Name</label>
              <div class="relative">
                <div class="flex flex-row relative">
                  <input v-model="form.name.value" placeholder="Name"
                  class="px-2 placeholder-theme-878686 block h-[40px] truncate relative border-none rounded bg-gray-black w-full text-sm text-theme-white"
                  min="0">
                </div>
              </div>
            </div>
          </div>
          <div class="w-2/3">
            <div :class="'input-wrapper '">
              <label class="text-xs mb-1">Reward Image</label>
              <div>
                <svg class="absolute top-[12px] left-1" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.820312 3.41406V2.8125C0.820312 2.38021 0.914062 1.98698 1.10156 1.63281C1.28906 1.27865 1.55729 0.994792 1.90625 0.78125C2.25521 0.567708 2.66927 0.460938 3.14844 0.460938C3.63802 0.460938 4.05469 0.567708 4.39844 0.78125C4.7474 0.994792 5.01562 1.27865 5.20312 1.63281C5.39062 1.98698 5.48438 2.38021 5.48438 2.8125V3.41406C5.48438 3.83594 5.39062 4.22396 5.20312 4.57812C5.02083 4.93229 4.75521 5.21615 4.40625 5.42969C4.0625 5.64323 3.64844 5.75 3.16406 5.75C2.67969 5.75 2.26042 5.64323 1.90625 5.42969C1.55729 5.21615 1.28906 4.93229 1.10156 4.57812C0.914062 4.22396 0.820312 3.83594 0.820312 3.41406ZM1.90625 2.8125V3.41406C1.90625 3.65365 1.95052 3.88021 2.03906 4.09375C2.13281 4.30729 2.27344 4.48177 2.46094 4.61719C2.64844 4.7474 2.88281 4.8125 3.16406 4.8125C3.44531 4.8125 3.67708 4.7474 3.85938 4.61719C4.04167 4.48177 4.17708 4.30729 4.26562 4.09375C4.35417 3.88021 4.39844 3.65365 4.39844 3.41406V2.8125C4.39844 2.56771 4.35156 2.33854 4.25781 2.125C4.16927 1.90625 4.03125 1.73177 3.84375 1.60156C3.66146 1.46615 3.42969 1.39844 3.14844 1.39844C2.8724 1.39844 2.64062 1.46615 2.45312 1.60156C2.27083 1.73177 2.13281 1.90625 2.03906 2.125C1.95052 2.33854 1.90625 2.56771 1.90625 2.8125ZM6.35938 9.82031V9.21094C6.35938 8.78385 6.45312 8.39323 6.64062 8.03906C6.82812 7.6849 7.09635 7.40104 7.44531 7.1875C7.79427 6.97396 8.20833 6.86719 8.6875 6.86719C9.17708 6.86719 9.59375 6.97396 9.9375 7.1875C10.2865 7.40104 10.5547 7.6849 10.7422 8.03906C10.9297 8.39323 11.0234 8.78385 11.0234 9.21094V9.82031C11.0234 10.2474 10.9297 10.638 10.7422 10.9922C10.5599 11.3464 10.2943 11.6302 9.94531 11.8438C9.60156 12.0573 9.1875 12.1641 8.70312 12.1641C8.21875 12.1641 7.80208 12.0573 7.45312 11.8438C7.10417 11.6302 6.83333 11.3464 6.64062 10.9922C6.45312 10.638 6.35938 10.2474 6.35938 9.82031ZM7.44531 9.21094V9.82031C7.44531 10.0599 7.48958 10.2891 7.57812 10.5078C7.67188 10.7214 7.8125 10.8958 8 11.0312C8.1875 11.1615 8.42188 11.2266 8.70312 11.2266C8.98438 11.2266 9.21615 11.1615 9.39844 11.0312C9.58594 10.8958 9.72396 10.7214 9.8125 10.5078C9.90104 10.2943 9.94531 10.0651 9.94531 9.82031V9.21094C9.94531 8.96615 9.89844 8.73698 9.80469 8.52344C9.71615 8.3099 9.57812 8.13802 9.39062 8.00781C9.20833 7.8724 8.97396 7.80469 8.6875 7.80469C8.41146 7.80469 8.17969 7.8724 7.99219 8.00781C7.8099 8.13802 7.67188 8.3099 7.57812 8.52344C7.48958 8.73698 7.44531 8.96615 7.44531 9.21094ZM9.04688 2.24219L3.49219 11.1328L2.67969 10.6172L8.23438 1.72656L9.04688 2.24219Z" fill="white"/>
                </svg>
                <div class="flex flex-row">
                  <file-manager v-model="form.image.value" classes="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest" label="SELECT" >
                    <template v-slot:custom="{ onClick }">
                      <div class="relative">
                        <input v-model="form.image.value" placeholder="image_(3).png"
                          class="px-2 pl-2 placeholder-theme-878686 block h-[40px] truncate relative border-none rounded bg-gray-black w-full text-sm text-theme-white"
                          min="0">
                        <button @click="onClick" class="absolute my-1 py-1 px-2 rounded border bg-gray-black  hover:bg-theme-green-300 border-theme-green top-[2.5px] text-sm leading-[17.5px] right-[8px]">Upload</button>
                      </div>
                    </template>
                  </file-manager>
                  
                  <div class="w-[20px] h-[40px] p-2">
                    <div v-if="index+1==total" @click="addReward" class="cursor-pointer">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z" fill="white"/>
                      </svg>
                    </div>
                    <div v-else @click="removeReward" class="cursor-pointer">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#F53333"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full xl:w-2/3" v-else-if="form.type.value=='discount_percentage'">
          <div :class="'input-wrapper ' + (form.discount.error_type)">
            <label class="text-xs mb-1">Reward</label>
            <div  class="relative">
              <svg class="absolute top-[13px] left-1" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.820312 3.41406V2.8125C0.820312 2.38021 0.914062 1.98698 1.10156 1.63281C1.28906 1.27865 1.55729 0.994792 1.90625 0.78125C2.25521 0.567708 2.66927 0.460938 3.14844 0.460938C3.63802 0.460938 4.05469 0.567708 4.39844 0.78125C4.7474 0.994792 5.01562 1.27865 5.20312 1.63281C5.39062 1.98698 5.48438 2.38021 5.48438 2.8125V3.41406C5.48438 3.83594 5.39062 4.22396 5.20312 4.57812C5.02083 4.93229 4.75521 5.21615 4.40625 5.42969C4.0625 5.64323 3.64844 5.75 3.16406 5.75C2.67969 5.75 2.26042 5.64323 1.90625 5.42969C1.55729 5.21615 1.28906 4.93229 1.10156 4.57812C0.914062 4.22396 0.820312 3.83594 0.820312 3.41406ZM1.90625 2.8125V3.41406C1.90625 3.65365 1.95052 3.88021 2.03906 4.09375C2.13281 4.30729 2.27344 4.48177 2.46094 4.61719C2.64844 4.7474 2.88281 4.8125 3.16406 4.8125C3.44531 4.8125 3.67708 4.7474 3.85938 4.61719C4.04167 4.48177 4.17708 4.30729 4.26562 4.09375C4.35417 3.88021 4.39844 3.65365 4.39844 3.41406V2.8125C4.39844 2.56771 4.35156 2.33854 4.25781 2.125C4.16927 1.90625 4.03125 1.73177 3.84375 1.60156C3.66146 1.46615 3.42969 1.39844 3.14844 1.39844C2.8724 1.39844 2.64062 1.46615 2.45312 1.60156C2.27083 1.73177 2.13281 1.90625 2.03906 2.125C1.95052 2.33854 1.90625 2.56771 1.90625 2.8125ZM6.35938 9.82031V9.21094C6.35938 8.78385 6.45312 8.39323 6.64062 8.03906C6.82812 7.6849 7.09635 7.40104 7.44531 7.1875C7.79427 6.97396 8.20833 6.86719 8.6875 6.86719C9.17708 6.86719 9.59375 6.97396 9.9375 7.1875C10.2865 7.40104 10.5547 7.6849 10.7422 8.03906C10.9297 8.39323 11.0234 8.78385 11.0234 9.21094V9.82031C11.0234 10.2474 10.9297 10.638 10.7422 10.9922C10.5599 11.3464 10.2943 11.6302 9.94531 11.8438C9.60156 12.0573 9.1875 12.1641 8.70312 12.1641C8.21875 12.1641 7.80208 12.0573 7.45312 11.8438C7.10417 11.6302 6.83333 11.3464 6.64062 10.9922C6.45312 10.638 6.35938 10.2474 6.35938 9.82031ZM7.44531 9.21094V9.82031C7.44531 10.0599 7.48958 10.2891 7.57812 10.5078C7.67188 10.7214 7.8125 10.8958 8 11.0312C8.1875 11.1615 8.42188 11.2266 8.70312 11.2266C8.98438 11.2266 9.21615 11.1615 9.39844 11.0312C9.58594 10.8958 9.72396 10.7214 9.8125 10.5078C9.90104 10.2943 9.94531 10.0651 9.94531 9.82031V9.21094C9.94531 8.96615 9.89844 8.73698 9.80469 8.52344C9.71615 8.3099 9.57812 8.13802 9.39062 8.00781C9.20833 7.8724 8.97396 7.80469 8.6875 7.80469C8.41146 7.80469 8.17969 7.8724 7.99219 8.00781C7.8099 8.13802 7.67188 8.3099 7.57812 8.52344C7.48958 8.73698 7.44531 8.96615 7.44531 9.21094ZM9.04688 2.24219L3.49219 11.1328L2.67969 10.6172L8.23438 1.72656L9.04688 2.24219Z" fill="white"/>
              </svg>
              <div class="flex flex-row">
                <input v-model="form.discount.value" @keyup="validateFields(['discount'])" :onkeypress="preventNonNumbers" placeholder="Enter value"
                    class="pl-[25px] placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"
                    min="0" type="number">
                <div class="w-[20px] h-[40px] p-2">
                  <div v-if="index+1==total" @click="addReward" class="cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z" fill="white"/>
                    </svg>
                  </div>
                  <div v-else @click="removeReward" class="cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#F53333"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <p class="field-error label-text mt-1" v-if="form.discount.error_message" v-text="form.discount.error_message"></p>
          </div>
        </div>

        <div class="w-full xl:w-2/3" v-else>
          <div :class="'input-wrapper ' + (form.discount.error_type)">
            <label class="text-xs mb-1">Reward</label>
            <div class="relative">
              <div class="flex flex-row">
                <span class="absolute top-[8px] left-1">$</span>
                <input v-model="form.discount.value" @keyup="validateFields(['discount'])" placeholder="Enter value"
                    class="pl-[25px] px-2 placeholder-theme-878686 block border-none rounded bg-gray-black w-full text-sm text-theme-white"
                    min="0" step="0.01" type="number">
                <div class="w-[20px] h-[40px] p-2">
                  <div v-if="index+1==total" @click="addReward" class="cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 7V11H7V13H11V17H13V13H17V11H13V7H11ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z" fill="white"/>
                    </svg>
                  </div>
                  <div v-else @click="removeReward" class="cursor-pointer">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#F53333"/>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <p class="field-error label-text mt-1" v-text="form.discount.error_message"></p>
          </div>
        </div>
      </div>
      <CategoryWithProductModal v-if="categoryWithproductObj.active" :existingproducts="selectedPids" :allSelectedSku="allSelectedSku"  :closeClick="closeCategoryWithProductModal" :actionClick="setCategoriesWithProduct"/>
</template>
<script>
import Helpers from '@/helpers';
import { defineComponent, ref } from 'vue'
import CategoryWithProductModal from '@/views/Membership/Program/RedeemPoints/CategoryWithProductModalSingleSelect.vue';
import FileManager from '@/components/manager/filemanager.vue'

export default defineComponent({
    props: ['reward', 'allSelectedSku', 'index', 'total'],
    components: {
      CategoryWithProductModal,
      FileManager
    },
    setup() {
        let form = ref({
            type: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required'],
            },
            discount: {
                value: '',
                error_type: '',
                error_message: '',
                validations: ['required|max:100'],
            },
            sku: {
                value: '',
                error_type: '',
                error_message: '',
                validations: [],
            },
            name: {
                value: '',
                error_type: '',
                error_message: '',
                validations: [],
            },
            image: {
                value: '',
                error_type: '',
                error_message: '',
                validations: [],
            },
            status: {
                value: true,
                error_type: '',
                error_message: '',
                validations: [],
            },
            variant: {
              value: '',
              error_type: '',
              error_message: '',
              validations: [],
            },
            pId: {
              value: '',
              error_type: '',
              error_message: '',
              validations: [],
            }
        })
        const categoryWithproductObj = ref({
          active: false,
        });
        const selectedPids = ref([]);

        return {
          form,
          selectedPids,
          categoryWithproductObj
        }
    },
    mounted(){
      this.form.type.value = this.reward.type
      this.form.status.value = true
      this.form.sku.value = this.reward.sku
      this.form.name.value = this.reward.name
      this.form.discount.value = this.reward.discount
      this.form.image.value = this.reward.image
      this.form.variant.value = this.reward.variant
      this.form.pId.value = this.reward.details?this.reward.details.productId:null
      this.selectedPids = [this.reward.sku]
    },
    watch: {
      form: {
        handler: async function(){
          let obj = {
            type: this.form.type.value, 
            status: true,
            discount: this.form.discount.value,
            sku: this.form.sku.value,
            name: this.form.name.value,
            image: this.form.image.value,
            variant: this.form.variant.value,
            pId: this.form.pId.value
          }
          if(this.reward.id){
            obj.id = this.reward.id
          }
          this.$emit('updateReward', this.index, obj)
        },
        deep: true
      },
      reward: {
        handler: function(){
          this.form.type.value = this.reward.type
          this.form.status.value = true,
          this.form.sku.value = this.reward.sku
          this.form.name.value = this.reward.name
          // this.form.discount.value = this.reward.discount
          this.form.image.value = this.reward.image
          this.form.variant.value = this.reward.variant
          this.selectedPids = [this.reward.sku]
        },
        deep: true
      }
    },
    methods: {
      addReward(){
        this.$emit('addBlankReward')
      },
      removeReward(){
        this.$emit('removeReward', this.index)
      },
      /**
       * Validation captures
       */
      async validateFields(fields) {
        let res = await Helpers.validateFormFields(this.form, fields);
        // capture the fields
        this.form = res.data;
        return res.error ? false : true;
      },
      /**
       * Open product with category Model
       */
      showCategoryWithProductModal() {
        this.categoryWithproductObj.active = true;
      },

      /**
       * Close select category modal
       */
      closeCategoryWithProductModal() {
        this.categoryWithproductObj.active = false;
      },

      /**
       * Get data selected from category modal
       */
      setCategoriesWithProduct(data) {
        if(data.products?.length>0){
          this.form.sku.value = data.products[0].sku
          this.form.name.value = data.products[0].name
          this.form.image.value = data.products[0].image
          this.form.variant.value = data.products[0].variant
          this.form.pId.value = data.products[0].id
        }
        this.closeCategoryWithProductModal();
      },

       /**
       * SetSelectedLocations
       */
      setSelectedLocations(data) {
        this.selectedLocationIds = data;
      },
    }
})
</script>
